import { IElection } from 'store/reducers/elections/types';

export type StageTone = 'done' | 'progress' | 'locked';

export type SeasonState = 'soon' | 'live' | 'closed' | 'results';

export function currentSeason(
    election: IElection | undefined,
    now = Date.now()
): SeasonState {
    if (!election || now < Date.parse(election.date_start)) return 'soon';
    if (now < Date.parse(election.date_end)) return 'live';
    return 'closed';
}

export function candidatesCaption(count: number): string {
    const last = count % 10;
    const lastTwo = count % 100;
    if (lastTwo >= 11 && lastTwo <= 14) return 'кандидатов';
    if (last === 1) return 'кандидат';
    if (last >= 2 && last <= 4) return 'кандидата';
    return 'кандидатов';
}

export function formatSchedule(start: Date, end: Date): string {
    const date = new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        timeZone: 'Europe/Moscow',
    });
    const time = new Intl.DateTimeFormat('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow',
    });
    const endDate =
        date.format(start) === date.format(end) ? '' : `${date.format(end)}, `;
    return `${date.format(start)}, ${time.format(
        start
    )}–${endDate}${time.format(end)} МСК`;
}
